import { Message, type UseChatHelpers } from "ai/react";

export type CustomComponent = {
  type: "tool-display";
  data: ToolDisplayData;
};

export interface ToolDisplayData {
  toolName: string;
  args: Record<string, any>;
}

export const TOOL_TYPES = {
  // Add tools as needed
} as const;

export const MAX_SESSION_NAME_LENGTH = 30;

export interface ChatSession {
  id: string;
  title: string;
  messages: Message[];
  s3FolderUrl: string | null;
  chatId: string | null;
  savedScrollPosition: number | null;
  createdAt: number;
}

export interface AskAnythingSessionContextType {
  sessions: ChatSession[];
  activeSessionId: string;
  createNewSession: () => void;
  switchSession: (sessionId: string) => void;
  updateSession: (id: string, updates: Partial<ChatSession>) => void;
}

export interface AskAnythingChatContextType {
  messages: Message[];
  input: string;
  handleSubmit: () => void;
  setInput: (input: string) => void;
  append: (message: Message) => void;
  reload: () => void;
  setMessages: (messages: Message[]) => void;
  status: UseChatHelpers["status"];
  reset: () => void;
  chatId: string | null;
  isDisabled: boolean;
  setIsDisabled: (disabled: boolean) => void;
  loadingText: string;
  savedScrollPosition: number | null;
  saveScrollPosition: (position: number) => void;
}

// Combined context type for backward compatibility and ease of use
// Chat properties are optional to support components that only use session context
export type AskAnythingCombinedContextType = AskAnythingSessionContextType &
  Partial<AskAnythingChatContextType>;
